import styled from "styled-components";
import { Link } from "react-router-dom";

export const TableContentStyled = styled.li`
  border: 1px solid transparent;
  display: inline-block;
  list-style-type: none;
  display: flex;
  font-size: ${({ theme }): string => theme.fontSize.unit(1.75)};
  color: ${({ theme }): string => theme.colors.onSurface};
  padding: ${({ theme }): string => theme.spacing.unit(0.5)}
    ${({ theme }): string => theme.spacing.unit(1)}
    ${({ theme }): string => theme.spacing.unit(0.5)}
    ${({ theme }): string => theme.spacing.unit(2)};
  border-radius: ${({ theme }): string => theme.borderRadiusTables} 0 0
    ${({ theme }): string => theme.borderRadiusTables};
  &:nth-child(even) {
    background-color: ${({ theme }): string => theme.colors.evenRowTable};
    border: 1px solid ${({ theme }): string => theme.colors.evenRowTable};
  }
  &:hover {
    cursor: pointer;
    background-color: ${({ theme }): string => theme.colors.tableHoverOpacity};
    border: 1px solid ${({ theme }): string => theme.colors.tableHover};
  }

  &:nth-child(1) {
    border-radius: ${({ theme }): string => theme.borderRadiusTables}
      ${({ theme }): string => theme.borderRadiusTables} 0
      ${({ theme }): string => theme.borderRadiusTables};
  }

  &:last-child {
    border-radius: ${({ theme }): string => theme.borderRadiusTables} 0
      ${({ theme }): string => theme.borderRadiusTables}
      ${({ theme }): string => theme.borderRadiusTables};
  }

  &:nth-child(1):last-child:hover {
    border-radius: ${({ theme }): string => theme.borderRadiusTables}
      ${({ theme }): string => theme.borderRadiusTables}
      ${({ theme }): string => theme.borderRadiusTables}
      ${({ theme }): string => theme.borderRadiusTables};
  }
`;

export const RowStyled = styled.span`
  padding-right: ${({ theme }): string => theme.spacing.unit(0.5)};
  word-break: break-all;
  max-width: ${({ theme }): string => theme.spacing.unit(10)};
  flex: 1;
  &:nth-child(3) {
    max-width: initial;
    flex: 1.2;
  }
  &:nth-child(5),
  &:nth-child(4) {
    flex: 0;
    min-width: ${({ theme }): string => theme.spacing.unit(5)};
  }
  &:last-child {
    flex: 0;
    min-width: ${({ theme }): string => theme.spacing.unit(4.4)};
    text-align: right;
  }
`;

export const DivStyled = styled.div`
  min-height: 1.25em;
`;

export const SmallSpanStyled = styled.span`
  display: block;
  vertical-align: bottom;
  font-size: ${({ theme }): string => theme.fontSize.unit(1.5)};
  margin-top: ${({ theme }): string => theme.spacing.unit(0.5)};
`;

export const ButtonStyled = styled.input`
  margin: 0 ${({ theme }): string => theme.spacing.unit(0.5)} 0 0;
`;

export const Icon = styled.img`
  vertical-align: middle;
  margin-right: ${({ theme }): string => theme.spacing.unit(0.25)};
`;

export const SmallString = styled.span`
  vertical-align: middle;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const LinkStyled = styled(Link)`
  color: ${({ theme }): string => theme.colors.primary};
`;
